import React, {useEffect, useState} from "react";
import {Box, CircularProgress} from "@material-ui/core";
import {
  PaymentReminderPreviewBroadcastChannel,
  PaymentReminderPreviewChannelName,
  PaymentReminderPreviewData,
} from "ts/app/payment-reminder/preview-payment-reminder.constraint";
import PaymentReminderEmailBody from "./PaymentReminderEmailBody";
import useStyles from "./styles";

/**
 * Standalone preview tab for the supplier Payment Reminder email. Opened in a
 * new browser tab from the editing modal; it asks the editor for the current
 * form content via a BroadcastChannel and re-renders live as the user types —
 * the same mechanism the Organiser email-template preview uses.
 */
const PaymentReminderPreviewPage = () => {
  const classes = useStyles();
  const [data, setData] = useState<PaymentReminderPreviewData | null>(null);

  useEffect(() => {
    const channel = new BroadcastChannel(PaymentReminderPreviewChannelName);

    // Ask the (possibly already-open) editing modal to push current content.
    const reloadMessage: PaymentReminderPreviewBroadcastChannel = {
      type: "reload",
    };
    channel.postMessage(reloadMessage);

    channel.onmessage = (
      event: MessageEvent<PaymentReminderPreviewBroadcastChannel>
    ) => {
      const {type, data: incoming} = event.data;
      if (type === "update" && incoming) {
        setData(incoming);
      }
    };

    return () => channel.close();
  }, []);

  if (!data) {
    return (
      <Box className={classes.loader}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box className={classes.page}>
      <PaymentReminderEmailBody {...data} />
    </Box>
  );
};

export default PaymentReminderPreviewPage;
